import * as React from 'react';
import { Translate } from '../../shared/LanguageService';
import ISe360User from './ISe360User';
import { Table } from 'react-bootstrap';
import Se360UserListRow from './Se360UserListRow';
import { assign } from '../../shared/Assign';

interface ISe360UserListProps {
    loggedInUser: any;
    items: ISe360User[];
    showRemoved: boolean;
    beginEdit: (id: number) => void;
    delete: (id: number) => void;
    restoreUser: (id: number) => void;
    handleSpecialAuthorizations: (id: number) => void;
    showLogs: (id: number) => void;
}

const Se360UserList = (props: ISe360UserListProps) => {
    return (
        <Table hover responsive>
            <thead>
                <tr>
                    <th>{Translate('se360users/list/header/name')}</th>
                    <th>{Translate('se360users/list/header/email-address')}</th>
                    <th>{Translate('se360users/list/header/phone-number')}</th>
                    <th>{Translate('se360users/list/header/role')}</th>
                    <th>{Translate('se360users/list/header/country')}</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                {assign([], props.items)
                    .sort((a: ISe360User, b: ISe360User) => {
                        if (a.name < b.name) {
                            return -1;
                        }
                        if (a.name > b.name) {
                            return 1;
                        }

                        return 0;
                    })
                    .filter((user) => (props.showRemoved ? true : user.isRemoved === false))
                    .map((u: ISe360User) => {
                        return (
                            <Se360UserListRow
                                loggedInUser={props.loggedInUser}
                                user={u}
                                key={u.id}
                                beginEdit={props.beginEdit}
                                delete={props.delete}
                                restoreUser={props.restoreUser}
                                handleSpecialAuthorizations={props.handleSpecialAuthorizations}
                                showLogs={props.showLogs}
                            />
                        );
                    })}
            </tbody>
        </Table>
    );
};

export default Se360UserList;
